"use strict";
/////<reference path="GlobalHelp.ts" />
//import Help from "./Help";
//import { Help } from "./Help";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapHelp = void 0;
var Help_js_1 = __importDefault(require("./Help.js")); //N.B. we use diff syntax here, adding the .js as this file is shared with the Mvp which doesn't want to use a module loader 
//rather it uses the ES2015 module loader, which will fail with no extension, but work if the page has downloaded a file called Help.js 
var MarkerTypes_js_1 = require("./MarkerTypes.js");
var MapHelp = /** @class */ (function () {
    function MapHelp() {
    }
    MapHelp.getGoogleMapsLink = function (building) {
        var buildingNameAndAddress = building.name + ", " + building.postcode;
        return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(buildingNameAndAddress);
    };
    MapHelp.getPopupHtml = function (item, typeInfo) {
        var _a, _b;
        var imgStyle = "";
        var defaultImg = "";
        if (!Help_js_1.default.isGoodString(item.img)) {
            defaultImg = "<i class=\"" + typeInfo.defaultIcon + " fa-2x\"></i>";
        }
        else {
            imgStyle = "style=\"background-image: url(" + item.img + ");\"";
        }
        //console.log(typeInfo.name);  
        var nameHtml = "";
        var descriptionHtml = (_a = item.description) !== null && _a !== void 0 ? _a : Help_js_1.default.singulariseWords(typeInfo.name);
        if ((typeInfo.name === "Tubes" || typeInfo.name === "Dlr" || typeInfo.name === "Trains") && Help_js_1.default.isGoodString(item.tflId)) { //if we add tflId to normal train stations it will go through here
            nameHtml = "<div class=\"tfl_lines\" data-tflId=\"" + item.tflId + "\"></div>";
            descriptionHtml = item.name + "<a class=\"a_tfl\" href=\"" + item.url + "\" target=\"_blank\" title=\"Station web page\">more info...</a>";
        }
        else if (typeInfo.name === "Cycles") {
            nameHtml = "<div class=\"bike_dock\" data-tflId=\"" + item.tflId + "\"></div>";
            descriptionHtml = "" + item.description;
        }
        else if (!Help_js_1.default.isGoodString(item.url)) {
            nameHtml = "<p class=\"name\">" + item.name + "</p>";
        }
        else {
            nameHtml = "<a href=\"" + item.url + "\" title=\"Visit Website\" target=\"_blank\"><p class=\"name\">" + item.name + "</p></a>";
        }
        var iconClass = (_b = item.icon) !== null && _b !== void 0 ? _b : typeInfo.defaultIcon; //TODO:TD if never used on marker itself then can drop and just use the typeInfo
        return "<div class=\"owl-item active center\" ><div class=\"item\">\n        <div class=\"testimony-wrap py-4\">\n        <div class=\"icon d-flex align-items-center justify-content-center\">\n        <span class=\"" + iconClass + "\" aria-hidden=\"true\">\n        </span></div>  \n        <div class=\"text\">\n        <p class=\"p_top\">" + descriptionHtml + "</p>\n        <p class=\"p_address\">" + item.address + ", " + item.postcode + "</p>  \n        <div class=\"d-flex align-items-center\">\n        <div class=\"user-img d-flex align-items-center justify-content-center\" " + imgStyle + ">\n            " + defaultImg + "\n        </div>\n        <div class=\"pl-3\">\n        " + nameHtml + "\n        <span class=\"position\">" + item.walk + " Min Walk, " + item.metres + "m</span>\n        </div>\n        </div>\n        </div>\n        </div>\n        </div></div>";
    };
    ;
    MapHelp.getLineStatusHtml = function (lines) {
        return lines.map(function (l) {
            var statusWarning = l.statusSeverity !== MarkerTypes_js_1.StatusSeverity.GoodService ? "warning" : "";
            var statusTitle = l.statusSeverity !== MarkerTypes_js_1.StatusSeverity.GoodService ? [l.reason, l.additionalInfo].filter(Help_js_1.default.isGoodString).join(" ") : "";
            return "<div class=\"line " + l.id + "\">\n                        <div class=\"line_block\">" + l.name + "</div>\n                        <div class=\"status_block " + statusWarning + "\" title=\"" + statusTitle + "\">" + l.statusSeverityDescription + "</div>\n                    </div>";
        }).join('');
    };
    MapHelp.getBikeRackStatusHtml = function (info) {
        return "<table><tbody>\n                    <tr><td>Bikes Available:</td><td class='count'>" + info.bikes + "</td></tr>\n                    <tr><td>Spaces:</td><td class='count'>" + info.spaces + "</td></tr>\n                </tbody></table>";
    };
    return MapHelp;
}());
exports.MapHelp = MapHelp;
//# sourceMappingURL=mapHelp.js.map